import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateRUStatusDashboardCarrierState } from '@api/ruStatusDashboard';

import { IRUStatusDashboardUpdateCarrierDTO } from '@interfaces/ruStatusDashboard/dto/ruStatusDashboardDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import {
	RU_DASHBOARD_ACTIVE_CARRIER_STATE,
	RU_DASHBOARD_STATUSES,
	RU_DASHBOARD_USAGE_CARRIER_STATE,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateRUDashboardStatusUpdateCarrierReturned {
	updateRUStatusDashboardCarrierState: UseMutateFunction<
		any,
		any,
		IRUStatusDashboardUpdateCarrierDTO,
		any
	>;
	isLoadingCarrierStatusUpdate: boolean;
}

export const useMutateRUDashboardStatusUpdateCarrier = (): IUseMutateRUDashboardStatusUpdateCarrierReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IRUStatusDashboardUpdateCarrierDTO>({
		mutationKey: [RU_DASHBOARD_USAGE_CARRIER_STATE],
		mutationFn: updateRUStatusDashboardCarrierState,
		allowedRoles: [EUserRoles.smoLightUpdater],
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updateRUDashboardCarrierState,
				type: ESnackbarTypes.success,
			}));

			return [
				queryClient.invalidateQueries([RU_DASHBOARD_STATUSES]),
				queryClient.invalidateQueries([RU_DASHBOARD_ACTIVE_CARRIER_STATE]),
			];
		},
	});

	return {
		updateRUStatusDashboardCarrierState: mutate,
		isLoadingCarrierStatusUpdate: isLoading,
	};
};
